export const shouldBeCompactItem = article => {
  const shouldBeCompact =
    (article.madia && article.media.image && article.media.image.thumbnail) ||
    false;

  return shouldBeCompact;
};
